import React from 'react';
import Icon from '../../../components/AppIcon';

const ColorStats = ({ colors }) => {
  const totalColors = colors?.length;
  const totalUsage = colors?.reduce((sum, color) => sum + color?.usageCount, 0);
  const avgUsage = totalColors > 0 ? (totalUsage / totalColors)?.toFixed(1) : 0;
  const mostUsedColor = colors?.length > 0 
    ? colors?.reduce((max, color) => color?.usageCount > max?.usageCount ? color : max, colors?.[0])
    : null;

  const stats = [
    {
      label: 'Total Colors',
      value: totalColors,
      icon: 'Palette',
      color: 'var(--color-primary)'
    },
    {
      label: 'Total Usage',
      value: totalUsage,
      icon: 'TrendingUp',
      color: 'var(--color-success)'
    },
    {
      label: 'Avg. Usage',
      value: avgUsage,
      icon: 'BarChart3',
      color: 'var(--color-accent)'
    },
    {
      label: 'Most Popular',
      value: mostUsedColor?.name || 'N/A',
      icon: 'Star',
      color: 'var(--color-warning)',
      subtitle: mostUsedColor ? `${mostUsedColor?.usageCount} uses` : ''
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {stats?.map((stat, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-4 transition-all duration-150 hover:shadow-md"
        >
          <div className="flex items-start justify-between mb-3">
            <div
              className="w-10 h-10 rounded-lg flex items-center justify-center"
              style={{ backgroundColor: `${stat?.color}15` }}
            >
              <Icon name={stat?.icon} size={20} color={stat?.color} />
            </div>
          </div>
          <div>
            <p className="text-2xl font-bold text-text-primary mb-1">
              {stat?.value}
            </p>
            <p className="text-sm text-text-secondary">
              {stat?.label}
            </p>
            {stat?.subtitle && (
              <p className="text-xs text-text-secondary mt-1">
                {stat?.subtitle}
              </p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ColorStats;